import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axiosApi from "helpers/api_helper"
import handleApiError from "../../../components/authGuard"

export const getAgents = createAsyncThunk(
    'agents/get',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosApi.get(
                'player/agents',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            const message = handleApiError(error);
            return rejectWithValue(message);
        }
    }
);

export const getConversations = createAsyncThunk(
    'conversations/get',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosApi.get(
                `messages/conversations/Player/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            const message = handleApiError(error);
            return rejectWithValue(message);
        }
    }
);

export const sendMessageToAgent = createAsyncThunk(
    'message/post',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosApi.post('messages/send', data,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
                    }
                }
            )
            return response.data
        } catch (err) {
            const message = handleApiError(err);
            return rejectWithValue(message);
        }
    }
)

const AGENT_TO_CHAT_KEY = "agentToChat";
// Création du Slice
const agentSlice = createSlice({
    name: "agents",
    initialState: {
        error: null,
        success: null,
        loading: null,
        agents: {},
        conversations: [],
        message: {},
        agentToChat: JSON.parse(localStorage.getItem(AGENT_TO_CHAT_KEY)) || null,
    },
    reducers: {
        setAgentToChat(state, action) {
            state.agentToChat = action.payload;
            localStorage.setItem(AGENT_TO_CHAT_KEY, JSON.stringify(action.payload));
        },
        clearAgentToChat(state) {
            state.agentToChat = null;
            localStorage.removeItem(AGENT_TO_CHAT_KEY);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAgents.pending, (state) => {
                state.success = null
                state.error = null
                state.loading = true
            })
            .addCase(getAgents.fulfilled, (state, action) => {
                state.agents = action.payload
                state.loading = false
            })
            .addCase(getAgents.rejected, (state, action) => {
                state.error = action.payload
                state.loading = false
            })

            .addCase(getConversations.pending, (state) => {
                state.success = null
                state.error = null
                state.loading = true
            })
            .addCase(getConversations.fulfilled, (state, action) => {
                state.conversations = action.payload
                state.loading = false
            })
            .addCase(getConversations.rejected, (state, action) => {
                state.error = action.payload
                state.loading = false
            })

            .addCase(sendMessageToAgent.pending, (state) => {
                state.success = null
                state.error = null
                state.loading = true
            })
            .addCase(sendMessageToAgent.fulfilled, (state, action) => {
                state.message = action.payload
                state.loading = false
            })
            .addCase(sendMessageToAgent.rejected, (state, action) => {
                state.error = action.payload
                state.loading = false
            })

    },
})

export const { setAgentToChat, clearAgentToChat } = agentSlice.actions;
export default agentSlice.reducer
